import { Categories } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetCategoriesResponse } from "../schema/GetCategoriesResponse";
import { mapCategories } from "../../mappers/partsServices/categoriesMapper";

export const getCategories = async (): Promise<Categories> => {
    const client = ApiClient.getInstance();

    try {
        const response = await client.get<GetCategoriesResponse>(`parts-services/categories`);
        return response.categories ? mapCategories(response.categories) : [];
    } catch (error: any) {
        return [];
    }
};
